import { render } from "./App.vue?vue&type=template&id=597bb59b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=597bb59b&lang=scss"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])